export const getAPIErrorMessage = (error, service) => {
  console.error(`Onboarding error: ${service} threw the following error: ${error}`)
    if (error.response) {
      const { status, data } = error.response;
  
      switch (status) {
        case 401:
          return 'Session expired. Please log in again.';
          
        case 400:
          return data?.message || 'Bad request. Please check your input.';
          
        case 500:
          return 'Internal server error. Please try again later.';
          
        default:
          return 'An unknown error occurred. Please try again.';
      }
    } else if (error.request) {
      return 'No response from the server. Please check your network connection.';
    } else {
      return 'Error occurred. Please try again.';
    }
  };
  